import _ from 'underscore'
export const serverPath = "http://drwebgrade.matf.bg.ac.rs/backend/server/services/";
export const lastSchoolYear = 2017;
export const thresholdForTestCase = 10;
export const rangListLimit = 50;
export const monthLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];

export const sponsors = [
    {
        src: '../src/assets/zbirka.jpg',
        altText: 'Zbirka P1',
        caption: 'Zbirka zadataka sa rešenjima za predmet Programiranje 1 nedavno je izašla iz štampe.',
        description: 'Može se nabaviti u skriptarnici fakulteta (kod Miše).',
        href: '#',
        key: 1
    },
    {
        src: '../src/assets/guestbook.png',
        altText: 'Iskustva korisnika',
        description: 'Dragi studenti, trenutno pripremamo razne novine i izmedju ostalog formiramo stranicu sa iskustvima korisnika, pa Vas molimo da izdvojite malo vremena za popunjavanje sledeće ankete, mnogo će nam značiti!',
        caption: 'Iskustva korisnika',
        href: 'https://docs.google.com/forms/d/e/1FAIpQLSenWFSBT70hNtBIwRL3cm-6ZJJLWMdNCTurvivcCCPjbU8pGA/viewform',
        key: 2
    }
];

export const defaultGraderForCourse = [
    { idCourse: 4, idGrader: 1 }
];

export const graderData = [
    { idGrader: 1, name: "C", defaultFlags: "-std=c99 -O2"},
    { idGrader: 2, name: "OS", defaultFlags: "-std=c99 -O2"},
    { idGrader: 3, name: "C++", defaultFlags: "-std=c++14 -O2"},
    { idGrader: 4, name: "C#", defaultFlags: ""},
    { idGrader: 5, name: "Pascal", defaultFlags: "-O2"},
    { idGrader: 6, name: "HaskellF", defaultFlags: "--fname=ime_funkcije"},
    { idGrader: 7, name: "Python", defaultFlags: ""},
    { idGrader: 8, name: "Java", defaultFlags: ""},
];

export const matcherData = [
    { name: 'IgnoreRegexMatcher', defaultArg: "\\s+", description: "Kao argument se navodi regularni izraz koji opicuje sta sve treba ignorisati pri poredjenju rezultata"},
    { name: 'SortMatcher', defaultArg: "int", description: "Kao argument se navodi tip podataka. SortMatcher ne radi za korisnicki definisane strukture."},
    { name: 'StringMatcher', defaultArg: "", description: "Nema argumenata. Rezultat se poredi na strogu jednakost."},
    { name: 'NumberMatcher', defaultArg: "0.0001", description: "Kao argument se navodi zeljena tacnost na koju se poredi rezultat."}
];

/**
 *
 * @param datetime in UNIX format
 * @returns {string} datetime in format YYYY.MM.DD HH:MM:SS
 */

export function convertDatetime(datetime){
    var tmp=datetime.split(" ");//tmp[0] is date, tmp[1] is time
    var newDate=convertDate(tmp[0]);
    return newDate + " " + tmp[1];
}
/**
 * 
 * @param {string} date in UNIX format
 * @returns {string} date in YYYY.MM.DD format
 */
export function convertDate(date){
    date = date.split("-");
    return date[2]+ "." + date[1] + "." + date[0] + ".";
}


/**
 * TODO: Dodati ekstenzije za ostale jezike!
 *
 * @param {string(number)} graderId
 * @returns {string} accepted file extension for given graderId
 */
export function getExtension(graderId){
    var extension = "";
    switch(graderId){
        case 1:
        case 2:
            extension = ".c";
            break;
        case 3:
            extension = ".cpp";
            break;
	case 4:
            extension = ".cs";
            break;
        case 5:
            extension = ".pas";
            break;
        case 6:
            extension = ".hs";
            break;
        case 7:
            extension = ".py";
            break;
        case 8:
            extension = ".java";
            break;
        default:
            console.log("unknown grader type");
            break;
    }
    return extension;
}

/*
 * @param styles object where each key is a new css proprety
 *
 * @description This function is made to be used with ref prop of html nodes to set styles with 
 * important. Advice for usage in constructor bind js object to style paramater and then use
 * that to pass to ref prop of html node this will be called twice onece when compnent is mounted
 * (el not null) and once when it is unmounted (el is null). If bound in render function this
 * will be called twice per render BIND IN CONSTRUCTOR 
 * NOTE
 * EACH KEY IS CAMEL CASE
 * if you use bind dont forget first to bind null as this or you can use
 * underscore partial
 *
 * */
export function setImportantStyles(styles, el)
{
	if(el)
	{
		_.each(styles, (val, key) =>
			{
				el.style.setProperty(camelCaseToDash(key), val, 'important');
			});
	}
}

function camelCaseToDash(key)
{
	return key.replace(/([a-z])([A-Z])/g, (match, p1, p2)=> p1 + '-' + p2.toLowerCase());
}

